import { call, fork, put, take, takeLatest } from 'redux-saga/effects';

import { REQUEST } from 'redux-config/reduxHelpers';

import { acceptError } from 'common/_redux';
import * as api from '../api';

import * as ActionTypes from './actions';

export function* getWazzupIframeSaga() {
  try {
    const { data, status } = yield call(api.getWazzupIframe);

    if (status === 409) {
      yield put(ActionTypes.setWazzupNeedAuth(true));

      return;
    }

    if (status < 300) {
      yield put(ActionTypes.getWazzupIframe.success(data));
    }
  } catch (e) {
    const detail = e?.response?.data?.detail;

    yield put(acceptError(detail || e, true));
    yield put(ActionTypes.getWazzupIframe.failure(detail || e));
  }
}

export function* getWazzupIframeWatcherSaga() {
  while (true) {
    yield take(ActionTypes.GET_WAZZUP_IFRAME[REQUEST]);
    yield call(getWazzupIframeSaga);
  }
}

export function* getWazzupContactIframeSaga({ contactId }) {
  try {
    const { data, status } = yield call(api.getWazzupIframe, contactId);
    yield put(ActionTypes.getWazzupContactIframe.success(contactId, status, status === 200 ? data.link : null));
  } catch (e) {
    yield put(ActionTypes.getWazzupContactIframe.failure(contactId, e?.response?.status || 500));
  }
}

export function* getWazzupContactIframeWatcherSaga() {
  yield takeLatest(ActionTypes.GET_WAZZUP_CONTACT_IFRAME[REQUEST], getWazzupContactIframeSaga);
}

export function* sendWazzupMessageSaga(action) {
  try {
    const payload = {
      contactId: action.contactId,
      channelId: action.channelId,
      chatType: action.chatType,
      text: action.text,
      phone: action.phone,
    };

    const { data, status } = yield call(api.sendWazzupMessage, payload);

    if (status < 300) {
      yield put(ActionTypes.sendMessageByWazzup.success(data));
    }
  } catch (e) {
    const detail = e?.response?.data?.detail || 'Failed to send message';
    yield put(ActionTypes.sendMessageByWazzup.failure(detail));
  }
}

export function* sendWazzupMessageWatcherSaga() {
  while (true) {
    const action = yield take(ActionTypes.SEND_WAZZUP_MESSAGE[REQUEST]);
    yield call(sendWazzupMessageSaga, action);
  }
}

export function* getWazzupAuthorizeUrlSaga() {
  try {
    const { status, data } = yield call(api.getWazzupAuthorizeUrl);
    if (status < 300) {
      yield put(ActionTypes.getWazzupAuthorizeUrl.success(data));
    } else {
      yield put(ActionTypes.getWazzupAuthorizeUrl.failure(data.detail));
    }
  } catch (e) {
    yield put(acceptError(e));
    yield put(ActionTypes.getWazzupAuthorizeUrl.failure());
  }
}

export function* getWazzupAuthorizeUrlWatcherSaga() {
  while (true) {
    const action = yield take(ActionTypes.GET_WAZZUP_AUTHORIZE_URL[REQUEST]);
    yield call(getWazzupAuthorizeUrlSaga, action);
  }
}

export function* getWazzupChannelsSaga() {
  try {
    const { data, status } = yield call(api.getWazzupChannels);

    if (status < 300) {
      yield put(ActionTypes.getWazzupChannels.success(data));
    } else {
      yield put(ActionTypes.getWazzupChannels.failure(data));
    }
  } catch (e) {
    yield put(ActionTypes.getWazzupChannels.failure(e));
  }
}

export function* getWazzupChannelsWatcherSaga() {
  while (true) {
    yield take(ActionTypes.GET_WAZZUP_CHANNELS[REQUEST]);
    yield call(getWazzupChannelsSaga);
  }
}

export default [
  fork(getWazzupIframeWatcherSaga),
  fork(getWazzupContactIframeWatcherSaga),
  fork(sendWazzupMessageWatcherSaga),
  fork(getWazzupAuthorizeUrlWatcherSaga),
  fork(getWazzupChannelsWatcherSaga),
];
